import { createAction, props } from '@ngrx/store';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { RoleDetailSaveModel } from '../../role-details/models/role-detail-save.model';

export const addRole = createAction('[Add Role] Add Role');

export const createRole = createAction('[Create Role] Create Role', props<{ role: RoleDetailSaveModel }>());

export const createRoleSuccess = createAction('[Add Role] Create Role Success', props<{ roleId: number }>());

export const createRoleFailure = createAction('[API] Create Role Failure', props<SingleGraphError>());
